import { useCallback } from 'react';

import { ReferralBonusNotification } from '@/api/common';
import { Modals } from '@/helpers/modals';
import { useSubscription } from '@/modules/realTime/hooks';
import { ConnectionStatus } from '@/modules/realTime/providers';
import { useModalsStore } from '@/store';

export const useReferralSystemNotifications = () => {
  const open = useModalsStore.use.open();

  const handleReferralNotification = useCallback(
    (data: ReferralBonusNotification) => {
      if (!data.text) return;

      open(Modals.RefBonusNotification);
    },
    [open]
  );

  useSubscription<ReferralBonusNotification>(
    'referral_system_notifications',
    handleReferralNotification
  );
};
